import React from "react";

const fmt = (n, d = 2) =>
  n?.toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

/**
 * The 4-card overview strip at the top of the Paper Trading page.
 *
 * Pure presentational — accepts a `portfolio` object and renders. Extracted
 * from PaperTrading.jsx (which was 401 lines) so the parent page stays a
 * thin orchestrator.
 */
export default function PortfolioStats({ portfolio }) {
  const totalPlColor = (portfolio?.total_pl ?? 0) >= 0 ? "#5C8D73" : "#C66B59";
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div className="rounded-2xl bg-white border border-[#EAE6E1] p-5" data-testid="stat-total-value">
        <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#6B7068] mb-1.5">Total value</div>
        <div className="font-mono-ticker text-2xl text-[#2A2F2B]">${fmt(portfolio?.total_value)}</div>
      </div>
      <div className="rounded-2xl bg-white border border-[#EAE6E1] p-5" data-testid="stat-cash">
        <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#6B7068] mb-1.5">Cash</div>
        <div className="font-mono-ticker text-2xl text-[#2A2F2B]">${fmt(portfolio?.cash)}</div>
      </div>
      <div className="rounded-2xl bg-white border border-[#EAE6E1] p-5" data-testid="stat-total-pl">
        <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#6B7068] mb-1.5">All-time P&amp;L</div>
        <div className="font-mono-ticker text-2xl" style={{ color: totalPlColor }}>
          {portfolio?.total_pl >= 0 ? "+" : ""}${fmt(portfolio?.total_pl)}
        </div>
        <div className="text-xs font-mono-ticker mt-0.5" style={{ color: totalPlColor }}>
          {portfolio?.total_pct >= 0 ? "+" : ""}{fmt(portfolio?.total_pct)}%
        </div>
      </div>
      <div className="rounded-2xl bg-white border border-[#EAE6E1] p-5">
        <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#6B7068] mb-1.5">Starting cash</div>
        <div className="font-mono-ticker text-2xl text-[#2A2F2B]">${fmt(portfolio?.starting_cash)}</div>
      </div>
    </div>
  );
}
